<template>
  <v-tooltip color="white" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" class="mr-1" :color="color" small>
        mdi-bell-outline
      </v-icon>
    </template>
    <div class="pt-2 pb-1" style="min-width: 220px">
      <h3
        class="black--text mb-2 text-center text-uppercase"
        v-html="label"
      ></h3>
      <div
        v-for="alert in alerts"
        :key="alert.id"
        class="mb-2 d-flex align-start"
        style="gap: 6px"
      >
        <v-icon size="16" :color="alertColor(alert)">mdi-bell-outline</v-icon>
        <div class="d-flex flex-column">
          <div class="black--text text-caption font-weight-bold">
            {{ ruleName(alert) }}
          </div>
          <div class="grey--text text--darken-2 text-caption">
            {{ measureText(alert) }}
          </div>
        </div>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import { measurePhrase } from "@/components/pricing-strategy/pricingStrategyUtils";
import { getFriendlyDayStrategy } from "@/utils.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "a-rms-strategy-day-alerts",
  props: {
    date: String,
    alerts: Array
  },
  computed: {
    label() {
      return getFriendlyDayStrategy(this.date, true);
    },
    // Con varios avisos el icono es uno solo: el del más grave. Tener dos o
    // tres campanas de colores distintos en una celda tan pequeña no dice más
    // de lo que dice la peor, y el detalle ya está en el tooltip.
    color() {
      return this.alertColor(
        this.alerts.reduce(
          (worst, alert) =>
            (alert.priority || 0) > (worst.priority || 0) ? alert : worst,
          this.alerts[0] || {}
        )
      );
    },
    ...mapState({
      highlight_priorities: state => state.highlight_priorities
    }),
    ...mapGetters({
      getPricingStrategyRuleOrGuardrailById:
        "getPricingStrategyRuleOrGuardrailById"
    })
  },
  methods: {
    // Misma escala de colores que Alertas, igual que en Recomendaciones
    alertColor(alert) {
      const priority = (this.highlight_priorities || []).find(
        p => p.id === (alert && alert.priority)
      );
      return priority ? priority.color : "grey";
    },
    ruleName(alert) {
      const rule = this.getPricingStrategyRuleOrGuardrailById(alert.rule_id);
      return (rule && rule.name) || alert.strategy_name || "";
    },
    measureText(alert) {
      return alert && alert.measure ? measurePhrase(this, alert) : "";
    }
  }
};
</script>
